import template from './timesheet.html';
import controller from './timesheet.controller';

let timesheetComponent = {
  restrict: 'E',
  template,
  controller
};

export default timesheetComponent;



// WEBPACK FOOTER //
// ./client/pages/timesheet/timesheet.component.js